export const version = "sha2/5.1.0";
//# sourceMappingURL=_version.js.map